import api from '@/utils/api';
import {
    GET_LIST_ROLE_GROUP,
    GET_SPECIFIC_ROLE_GROUP,
    UPDATE_SPECIFIC_ROLE_GROUP,
    CREATE_NEW_ROLE_GROUP,
    REMOVE_ROLE_GROUP,
    GET_ROLE_GROUP_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListRoleGroup = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/role-groups', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_ROLE_GROUP, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificRoleGroup = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/role-groups/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_ROLE_GROUP, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getRoleGroupActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/role-groups/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_ROLE_GROUP_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createRoleGroup = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/role-groups', data).then(res => {
            dispatch({ type: CREATE_NEW_ROLE_GROUP, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateRoleGroup = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/role-groups/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_ROLE_GROUP, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeRoleGroup = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/role-groups`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_ROLE_GROUP, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
